export default "__VITE_ASSET__72f954db__"